import React from "react";
import {
  Redirect,
  Route,
  RouteComponentProps,
  Switch,
  useLocation
} from "react-router-dom";

export interface SetupParams {
  [key: string]: any;
}

export interface SetupRouteComponentProps<P = SetupParams>
  extends Partial<RouteComponentProps> {
  onBack?: (context?: any) => void;
  onNext: (context?: any) => void;
  params?: P;
}

export type SetupRouteConfig = {
  path: string;
  component: React.FC<SetupRouteComponentProps>;
  onBack?: (context?: { [key: string]: any }) => void;
  onNext: (context?: { [key: string]: any }) => void;
  exact?: boolean;
  [key: string]: any;
};

type Props = {
  routes: SetupRouteConfig[];
  basePath: string;
  params?: SetupParams;
  initialPath?: string;
};

export const FlowSetup: React.FC<Props> = ({
  routes,
  basePath,
  initialPath,
  params
}) => {
  const location = useLocation();

  const redirectPath = initialPath || routes[0].path;

  return (
    <Switch>
      {routes.map(route => {
        const { path, exact, component: Component, ...otherProps } = route;

        return (
          <Route
            key={path}
            exact={exact}
            path={basePath + path}
            render={({ history, location, match }) => (
              <Component
                history={history}
                location={location}
                match={match}
                params={params}
                {...otherProps}
              />
            )}
          />
        );
      })}

      {redirectPath && (
        <Redirect
          exact
          from={basePath}
          to={basePath + redirectPath + location.search}
        />
      )}
    </Switch>
  );
};
